<template>
  <div class="page-container">
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <Header @toggleSidebar="toggleSidebar" />

    <div class="page-content">
      <div class="global-bg" :style="{backgroundImage: `url(${require('@/assets/images/section-bg.png')})`}"></div>
      <Login />
    </div>

    <footer-one />
    <div class="go-top-area">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Drawer from "@/components/Mobile/Drawer.vue";
import FooterOne from "@/components/Utility/Footer/FooterOne.vue";
import Header from "@/components/Utility/Header/index.vue";
import Login from '@/components/Auth/login.vue';
export default {
  components: {
    Header,
    FooterOne,
    Drawer,
    Login,
  },
  data: () => ({
    sidebar: false,
  }),
  created() {
    document.addEventListener("scroll", this.topToBottom);
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.classList.add("active");
      } else {
        result.classList.remove("active");
      }
    }
  },
};
</script>